import { action } from "@ember/object";
import { service } from "@ember/service";
import ChatChannelPane from "./chat-channel-pane";

export default class ChatThreadPane extends ChatChannelPane {
  @service router;

  get thread() {
    return this.channel?.activeThread;
  }

  get isOpened() {
    return (
      this.router.currentRoute.name === "chat.channel.thread" ||
      this.router.currentRoute.name === "chat.channel.thread.index"
    );
  }

  get selectedMessageIds() {
    return this.thread.messagesManager.selectedMessages.map((item) => item.id);
  }

  @action
  cancelSelecting() {
    this.selectingMessages = false;
    this.thread.messagesManager.clearSelectedMessages();
  }

  async close() {
    await this.router.transitionTo("chat.channel", ...this.channel.routeModels);
  }

  async open(thread) {
    await this.router.transitionTo(
      "chat.channel.thread",
      ...thread.routeModels
    );
  }
}
